
import { useNavigate } from "react-router-dom";
import { format } from "date-fns";
import { Button } from "@/components/ui/button";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { AssessmentRecord } from "@/types/assessment";

interface AssessmentListProps {
  assessments: AssessmentRecord[];
}

export const AssessmentList = ({ assessments }: AssessmentListProps) => {
  const navigate = useNavigate();
  
  const handleViewAssessment = (assessmentId: string) => {
    navigate(`/assessment-history/${assessmentId}`);
  };
  
  return (
    <div className="rounded-md border">
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>Organization</TableHead>
            <TableHead>Date & Time</TableHead>
            <TableHead>Industry</TableHead>
            <TableHead>Status</TableHead>
            <TableHead className="text-right">Action</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {assessments.map((assessment) => (
            <TableRow key={assessment.id}>
              <TableCell className="font-medium">
                {assessment.organization_details.name}
              </TableCell>
              <TableCell>
                {assessment.created_at
                  ? format(new Date(assessment.created_at), "PPp") // Added "p" to also show time
                  : "N/A"}
              </TableCell>
              <TableCell>{assessment.organization_details.industry}</TableCell>
              <TableCell>Completed</TableCell>
              <TableCell className="text-right">
                <Button 
                  variant="outline"
                  onClick={() => handleViewAssessment(assessment.id)}
                >
                  View Details
                </Button>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
};
